import bowser from 'bowser'
import { useState, useRef, useEffect } from 'react'
import { stopPropagation } from '../../utils'

export default ({
  svgIcons,
  iconName,
  additionalClass,
  hasClickIcon,
  onClick = () => undefined,
  disabled,
  eventsOnContainer,
  holdButtonEnabled,
  injectedElement,
  reference,
}) => {
  const [iconState, setIconState] = useState('-idle')
  const holdTimeoutRef = useRef(null)
  const svgIconElementRef = useRef(null)
  const currentOnClick = useRef(null)

  useEffect(() => {
    svgIconElementRef.current.addEventListener('onClickForIosDelay', customOnClickHandler)
    return () => {
      svgIconElementRef.current.removeEventListener('onClickForIosDelay', customOnClickHandler)
      stopHoldTimeout()
    }
  }, [])

  useEffect(() => {
    if (disabled) {
      stopHoldTimeout()
    }
  }, [disabled])

  useEffect(() => {
    currentOnClick.current = onClick
  }, [onClick])

  const customOnClickHandler = e => {
    currentOnClick.current(e)
    return stopPropagation(e)
  }

  const startHoldTimeout = (event, delay) => {
    holdTimeoutRef.current = setTimeout(() => {
      onClick(event)
      if (holdTimeoutRef.current) {
        startHoldTimeout(event, Math.max(150, delay * 0.66))
      }
    }, delay)
  }

  const stopHoldTimeout = () => {
    if (holdButtonEnabled && holdTimeoutRef.current) {
      clearTimeout(holdTimeoutRef.current)
      holdTimeoutRef.current = null
    }
  }

  if (disabled && iconState !== '-idle') {
    setIconState('-idle')
  }

  const icon = svgIcons.find(e => e.props.id === `${iconName}${iconState}`)

  const onMouseEnter = () => {
    if (!disabled && !bowser.mobile && !bowser.tablet) {
      setIconState('-hover')
    }
  }

  const onMouseLeave = () => {
    if (!disabled) {
      setIconState('-idle')
    }
    stopHoldTimeout()
  }

  const onPointerDown = e => {
    if (!disabled && hasClickIcon && e.button === 0) {
      setIconState('-clicked')
      if (holdButtonEnabled) {
        if (holdTimeoutRef.current) {
          return
        }
        startHoldTimeout(e, 1000)
      }
    }
  }

  const onPointerUp = e => {
    if (!disabled && hasClickIcon && e.button === 0) {
      if (!bowser.mobile && !bowser.tablet) {
        setIconState('-hover')
      } else {
        setIconState('-idle')
      }
    }
    stopHoldTimeout()
  }

  let svgWrapperProps, svgGroupProps = {}
  const eventsList = {
    onMouseEnter,
    onMouseLeave,
    onPointerDown,
    onPointerUp,
    onClick,
  }
  if (eventsOnContainer) {
    svgWrapperProps = {
      className: `svg-container ${additionalClass ? additionalClass : ''} ${disabled ? 'disabled' : 'enable-pointer-events'}`,
      ref: reference,
      ...eventsList,
    }
  } else {
    svgWrapperProps = {
      className: `svg-container ${additionalClass ? additionalClass : ''}`,
      ref: reference,
    }
    svgGroupProps = {
      className: `svg-group ${disabled ? 'disabled' : 'enable-pointer-events'}`,
      ...eventsList,
    }
  }

  return (
    <div
      {...svgWrapperProps}
    >
      <svg
        className="svg-icon"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        x="0"
        y="0"
        viewBox="0 0 300 300"
        xmlSpace="preserve"
        ref={svgIconElementRef}
      >
        <g {...svgGroupProps}>
          {icon}
          {injectedElement}
        </g>
      </svg>
    </div>
  )
}